<!-- #region Mobile interior navigation -->
<nav
  *ngIf="requiresNavbar"
  class="navbar navbar-light bg-light d-block d-sm-none sticky-top"
>
  <div class="container-fluid">
    <a routerLink="{{ backNavigation }}">
      <i class="bi bi-chevron-left"></i>
      {{ backTitle }}
    </a>
  </div>
</nav>
<!-- #endregion -->

<div class="container-fluid">
  <div class="row">
    <div class="col-5 col-lg-3 bg-sidebar p-0">
      <div
        class="sidebar d-none d-md-block d-flex justify-content-center w-100"
      >
        <div class="sticky-top pt-5">
          <img
            class="center-block"
            src="../../../assets/images/sims-furniture-logo.png"
            height="125"
            alt="Sims Furniture Logo"
          />
          <h1 class="mt-5">
            SHOP NOW.<br />
            PAY LATER.
          </h1>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-8 content">
      <!-- #region General interior navigation -->
      <div *ngIf="requiresNavbar" class="d-none d-sm-block">
        <div class="row">
          <div class="col">
            <a routerLink="{{ backNavigation }}">
              <i class="bi bi-chevron-left"></i>
              {{ backTitle }}
            </a>
          </div>
        </div>
      </div>
      <!-- #endregion -->

      <!-- #region Mobile -->
      <div class="d-sm-block d-md-none mt-2">
        <div class="d-flex justify-content-center">
          <img
            src="../../../assets/images/sims-furniture-logo.png"
            height="100"
            alt="Sims Furniture Logo"
          />
        </div>
        <hr class="hr-style" />
      </div>
      <!-- #endregion -->

      <h1 class="text-primary">Credit Application</h1>

      <app-error-alert></app-error-alert>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
